import { render, staticRenderFns } from "./contact2.vue?vue&type=template&id=4fb32294&scoped=true"
import script from "./contact2.vue?vue&type=script&lang=js"
export * from "./contact2.vue?vue&type=script&lang=js"
import style0 from "./contact2.vue?vue&type=style&index=0&id=4fb32294&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb32294",
  null
  
)

export default component.exports